import React from "react"

import styles from "./index.module.css"

/**
 * @param {object} props
 * @param {{title: string, href: string}[]} props.tags
 */
export const CaseTags = ({ tags }) => {
  return (
    <div className={styles.Wrap}>
      {tags.map((t) => (
        <div key={t.title} className={styles.CaseTag}>
          <a href={t.href}>{t.title}</a>
        </div>
      ))}
    </div>
  )
}
